export class Sucursal {
	sucursalId: string;
	nombre: string;
	emisorId: string;
	direccion: string;
	certificadoDigitalId: string;
	activa: boolean;
	emisorNombre: string;
	showActions?: boolean;
	public markedForDeletion: boolean = false;
}
